document.addEventListener('DOMContentLoaded', function() {
    const descriptionBlock = document.querySelector('.description-block-2');

    if (descriptionBlock) {
        // Prendi l'HTML interno (per preservare eventuali link o altri tag)
        let rawHtml = descriptionBlock.innerHTML;

        // Dividi il contenuto in base ai <br>
        // Usiamo una regex per gestire anche spazi o slash nel <br>
        const lines = rawHtml.split(/<br\s*\/?>/i); // Dividi per <br> case-insensitive

        let ulHtml = '<ul>';
        lines.forEach(line => {
            const trimmedLine = line.trim(); // Rimuovi spazi all'inizio/fine della riga

            // Controlla se la riga inizia con un trattino seguito da uno spazio
            if (trimmedLine.startsWith('- ')) {
                // Rimuovi il trattino e lo spazio iniziale, poi avvolgi in <li>
                ulHtml += `<li>${trimmedLine.substring(2)}</li>`;
            } else if (trimmedLine.length > 0) {
                // Gestisce righe non-lista che potrebbero esserci (es. un paragrafo iniziale)
                // Puoi decidere se includerle in un <li> o in un <p> a parte
                ulHtml += `<li>${trimmedLine}</li>`; // O puoi avvolgerle in <p> se preferisci
            }
        });
        ulHtml += '</ul>';

        // Sostituisci il contenuto originale del div con la nuova lista HTML
        descriptionBlock.innerHTML = ulHtml;
    }
});